import '../styles/PlaylineLabel.scss';
import PaylineImg from '../assets/payline-default.png';
import WinnerImg from '../assets/payline-winner.png';

export default function PaylineLabel( {position, gameState, result}){

    const getWinState = () => {
        if (gameState!==3) return '';
        if (result==='vvv'||result==='hhh'||result==='bbb') return 'win';
        return 'loss';
    }

    return (
        <div className={`playlineLabel ${position} ${gameState===2?'dark':''} ${getWinState()}`}>
            <img className={getWinState().indexOf('win')!==-1?'hidden':''} src={PaylineImg} alt="Payline" />
            <img className={getWinState().indexOf('win')===-1?'hidden':''} src={WinnerImg} alt="Winner" />
        </div>
    )
}